import { Text } from 'slate';

import hasPluginOfType from './has_plugin_of_type';
import serializeHtmlText from './serialize_html_text';

// Serializes for external sources, such as emails. Ensures we don't leave stray, non-standard HTML tags in,
// such as variables or placeholders.
export default function serializeHtml(editor) {
  return serializeNode(editor, editor);
}

function serializeNode(editor, node) {
  if (Text.isText(node)) {
    return serializeHtmlText(node);
  }

  const children = node.children.map(n => serializeNode(editor, n)).join('');

  switch (node.type) {
    case 'p': {
      if (children === '') {
        return `<div><br></div>`;
      }
      return `<div>${children}</div>`;
    }
    case 'a': {
      if (!hasPluginOfType(editor, 'a')) {
        return children;
      }
      return `<a href="${node.url}" target="_blank" rel="noopener noreferrer">${children}</a>`;
    }
    default:
      return children;
  }
}
